import './legacy/landing.css';



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_landing/index.ts